import {useState} from 'react';
import {useTranslation} from "react-i18next";

function InfosContent({register, required, errors}) {
  const { t } = useTranslation();

  const [slider, setSlider] = useState(0);
  const [summary_char_count, setSummaryCharCount] = useState(0);

  const disabled_inputs = false && <div className="c-write_input">
    <div className="c-content title">
      <p>{t('Langue')}</p>
      <select type="text" name="language" {...register("language", { required : true})}>
        <option value="français">{t('Français')}</option>
        <option value="anglais">{t('Anglais')}</option>
      </select>
      {errors.language && <div className="c-errors">{t('Une langue est obligatoire')}</div>}
    </div>
    <div className="c-content title">
      <p>{t('Compression')}</p>
      <span id="number_range">{slider}%</span>
      <input {...register("compression", { required : false})} type="range" min="0" max="100" className="c-slider" id="myRange" onChange={(e) => setSlider(e.target.value)} />
    </div>
  </div>

  return (
    <div>
      <div className="c-write infos">
        <div className="c-write_header">
          <span className="c-header_number">5</span>
          <p className="c-header_title">{t('Autres informations')}</p>
        </div>
        <div className="c-write_content">
          { disabled_inputs }
          <div className="c-content text">
            <p>{t('Résumé')}</p>
            <textarea {...register("summary", {required: false})}
                      onChange={(e) => setSummaryCharCount(e.target.value.length)}>
            </textarea>
            <p>{summary_char_count}</p>
          </div>
        </div>
      </div>
    </div>
  )
}


export default InfosContent
